import { Tooltip } from '@/shared/components/Tooltip';
import { ImageUpload } from '@/shared/components/ImageUpload';
import ToolTipIcon from '../../../assets/svg/ToolTip.svg';
import { PROFILE_PICTURE_LABELS } from './constants';

interface ProfilePictureUploadProps {
  onFileChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onDelete?: (() => void) | undefined;
  onError?: ((message: string) => void) | undefined;
  onPreviewClick?: (() => void) | undefined;
  disabled?: boolean;
  initialLetter?: string;
  profileFile?: File | undefined;
  existingImageUrl?: string | undefined;
}

export const ProfilePictureUpload = ({
  onFileChange,
  onDelete,
  onError,
  onPreviewClick,
  disabled = false,
  initialLetter = 'A',
  profileFile,
  existingImageUrl,
}: ProfilePictureUploadProps) => {
  return (
    <div className="flex flex-col items-start gap-2">
      <ImageUpload
        onFileChange={onFileChange}
        onDelete={onDelete}
        onError={onError}
        onPreviewClick={onPreviewClick}
        disabled={disabled}
        initialLetter={initialLetter}
        profileFile={profileFile}
        existingImageUrl={existingImageUrl}
      />

      <div className="flex items-center gap-1">
        <span className="text-bodyLarge text-on-surface-variant whitespace-nowrap">
          {PROFILE_PICTURE_LABELS.TITLE}{' '}
          <span className="text-bodySmall">
            ({PROFILE_PICTURE_LABELS.OPTIONAL})
          </span>
        </span>
        <Tooltip
          content={
            <div className="w-full text-left">
              {PROFILE_PICTURE_LABELS.TOOLTIP_TITLE}
              <br />
              &nbsp;&nbsp;• {PROFILE_PICTURE_LABELS.TOOLTIP_FORMAT}
              <br />
              &nbsp;&nbsp;• {PROFILE_PICTURE_LABELS.TOOLTIP_SIZE}
            </div>
          }
          align="center"
          multiline={true}
          contentMinWidth={275}
        >
          <div className="w-6 h-6 cursor-pointer">
            <ToolTipIcon />
          </div>
        </Tooltip>
      </div>
    </div>
  );
};
